import { SUB_TYPE_NAMES } from '../../filters/virtual-infrastructure-type-filter/SubTypeHelper';
import { DEVICE_TYPE_NAMES } from '../../filters/monitored-infrastructure-type-filter/DeviceTypeHelper';

/**
 * Power state display mapping
 */
export const POWER_STATES = {
    poweredOn: 'On',
    poweredOff: 'Off',
    unknown: 'Unknown',
};

/**
 * Formats server subtype for display
 * @param {string} serverSubType - Raw subtype value
 * @returns {string} Formatted subtype name
 */
export const serverSubTypeFormatter = (serverSubType) => {
    return SUB_TYPE_NAMES[serverSubType] || serverSubType;
};

/**
 * Formats device type for display
 * @param {string} serverDeviceType - Raw device type value
 * @returns {string} Formatted device type name
 */
export const serverDeviceTypeFormatter = (serverDeviceType) => {
    return DEVICE_TYPE_NAMES[serverDeviceType] || serverDeviceType;
};

/**
 * Formats power state for display
 * @param {string} powerState - Raw power state value
 * @returns {string} Formatted power state text
 */
export const powerStateFormatter = (powerState) => {
    return POWER_STATES[powerState] || powerState;
};
